import ActionTypePlan from "../ActionTypePlan";

export default class FinalizarComando extends ActionTypePlan {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        return nuevoEstado;
    }
}
